import React, { useCallback } from 'react';
import { Button, ButtonTheme } from '@apply/components';
import { DemoSection } from './common/SectionNavigator';
import { DemoExample, DemoPage, DemoPageSection } from './common/DemoLayout';

const sections: DemoSection[] = [
    { id: 'buttonDemo_primary', title: 'Primary' },
    { id: 'buttonDemo_requestdraw', title: 'Secondary' },
    { id: 'buttonDemo_tertiarycta', title: 'Tertiary' },
    { id: 'buttonDemo_decline', title: 'Decline' },
    { id: 'buttonDemo_bluelink', title: 'Blue Link' },
    { id: 'buttonDemo_redlink', title: 'Red Link' },
    { id: 'buttonDemo_choice', title: 'Choice' },
];

export const ButtonDemo: React.FC = () => {
    const buttonClick: React.MouseEventHandler = useCallback((event) => {
        alert(event.currentTarget.id + ' clicked.');
    }, []);

    return (
        <DemoPage
            title='Button :'
            sections={sections}
        >
            <DemoPageSection
                id={sections[0].id}
                title={sections[0].title}
            >
                <DemoExample>
                    <Button
                        id='primaryButton'
                        theme={ButtonTheme.Primary}
                        width='314px'
                        handleClick={buttonClick}
                    >
                        New Application
                    </Button>
                </DemoExample>
                <DemoExample>
                    <Button
                        id='primaryButton-disabled'
                        theme={ButtonTheme.Primary}
                        width='314px'
                        handleClick={buttonClick}
                        disabled={true}
                    >
                        New Application (Disabled)
                    </Button>
                </DemoExample>
            </DemoPageSection>
            <DemoPageSection
                id={sections[1].id}
                title={sections[1].title}
            >
                <DemoExample>
                    <Button
                        id='secondaryButton'
                        theme={ButtonTheme.Secondary}
                        width='192px'
                        handleClick={buttonClick}
                    >
                        Request Draw
                    </Button>
                </DemoExample>
                <DemoExample>
                    <Button
                        id='secondaryButton-disabled'
                        theme={ButtonTheme.Secondary}
                        width='192px'
                        handleClick={buttonClick}
                        disabled={true}
                    >
                        Request Draw (Disabled)
                    </Button>
                </DemoExample>
            </DemoPageSection>
            <DemoPageSection
                id={sections[2].id}
                title={sections[2].title}
            >
                <DemoExample>
                    <Button
                        id='tertiaryButton'
                        theme={ButtonTheme.Tertiary}
                        width='184px'
                        handleClick={buttonClick}
                    >
                        Tertiary CTA
                    </Button>
                </DemoExample>
                <DemoExample>
                    <Button
                        id='tertiaryButton-disabled'
                        theme={ButtonTheme.Tertiary}
                        width='184px'
                        handleClick={buttonClick}
                        disabled={true}
                    >
                        Tertiary CTA Disabled
                    </Button>
                </DemoExample>
            </DemoPageSection>
            <DemoPageSection
                id={sections[3].id}
                title={sections[3].title}
            >
                <DemoExample>
                    <Button
                        id='declineButton'
                        theme={ButtonTheme.Decline}
                        width='334px'
                        handleClick={buttonClick}
                    >
                        Decline
                    </Button>
                </DemoExample>
                <DemoExample>
                    <Button
                        id='declineButton-disabled'
                        theme={ButtonTheme.Decline}
                        width='334px'
                        handleClick={buttonClick}
                        disabled={true}
                    >
                        Decline Disabled
                    </Button>
                </DemoExample>
            </DemoPageSection>
            <DemoPageSection
                id={sections[4].id}
                title={sections[4].title}
            >
                <DemoExample>
                    <Button
                        id='linkBlueButton'
                        theme={ButtonTheme.LinkBlue}
                        width='220px'
                        handleClick={buttonClick}
                    >
                        Blue Link Theme
                    </Button>
                </DemoExample>
                <DemoExample>
                    <Button
                        id='linkBlueButton-disabled'
                        theme={ButtonTheme.LinkBlue}
                        width='220px'
                        handleClick={buttonClick}
                        disabled={true}
                    >
                        Blue Link Theme Disabled
                    </Button>
                </DemoExample>
            </DemoPageSection>
            <DemoPageSection
                id={sections[5].id}
                title={sections[5].title}
            >
                <DemoExample>
                    <Button
                        id='linkRedButton'
                        theme={ButtonTheme.LinkRed}
                        width='220px'
                        handleClick={buttonClick}
                    >
                        Red Link Theme
                    </Button>
                </DemoExample>
                <DemoExample>
                    <Button
                        id='linkRedButton-disabled'
                        theme={ButtonTheme.LinkRed}
                        width='220px'
                        handleClick={buttonClick}
                        disabled={true}
                    >
                        Red Link Theme Disabled
                    </Button>
                </DemoExample>
            </DemoPageSection>
            <DemoPageSection
                id={sections[6].id}
                title={sections[6].title}
            >
                <DemoExample>
                    <Button
                        id='choiceButton-enabled'
                        theme={ButtonTheme.Choice}
                        width='220px'
                        handleClick={buttonClick}
                        disabled={false}
                    >
                        <div>Choice Enabled</div>
                    </Button>
                </DemoExample>
                <DemoExample>
                    <Button
                        id='choiceButton-disabled'
                        theme={ButtonTheme.Choice}
                        width='220px'
                        handleClick={buttonClick}
                        disabled={true}
                    >
                        <div>Choice Disabled</div>
                    </Button>
                </DemoExample>
            </DemoPageSection>
        </DemoPage>
    );
};
